import React, { useEffect, useState } from 'react';
import * as Sentry from '@sentry/react';
import ReportChart from './ReportChart';
// import DropDown from '../../../common/DropDown';
import { STANDARDS, SHOW_UNIT } from './consants';
import { numberWithCommas } from '../../../common/utils';
import './styles.scss';
import PropTypes from 'prop-types';
import LoadingComponent from '../../../common/LoadingComponent';

const getUpdatedData = (filter, f, data) => {
    return new Promise((resolve, reject) => {
        try {
            const filterCategory =
                filter.indexOf('category') > -1
                    ? filter.slice(0, filter.indexOf('category'))
                    : filter;
            const filterObject =
                filter.indexOf('object') > -1
                    ? filter.slice(0, filter.indexOf('object'))
                    : filter;
            const filterMaterial =
                filter.indexOf('material') > -1
                    ? filter.slice(0, filter.indexOf('material'))
                    : filter;
            const filterBrand =
                filter.indexOf('brand') > -1
                    ? filter.slice(0, filter.indexOf('brand'))
                    : filter;
            const filterOther =
                filter.indexOf('other') > -1
                    ? filter.slice(0, filter.indexOf('other'))
                    : filter;
            const filterUnclassified =
                filter.indexOf('unclassified') > -1
                    ? filter.slice(0, filter.indexOf('unclassified'))
                    : filter;
            let totalCategory = 0;
            let totalBrand = 0;
            let totalObject = 0;
            let totalMaterial = 0;
            let totalOther = 0;
            let totalUnclassified = 0;
            data.forEach((d) => {
                if (filterCategory.length) {
                    if (filterCategory.every((p) => d[p] == f[p]))
                        totalCategory += parseInt(d.litterCount);
                } else if (d.category) {
                    totalCategory += parseInt(d.litterCount);
                }

                if (filterBrand.length) {
                    if (filterBrand.every((p) => d[p] == f[p]))
                        totalBrand += parseInt(d.litterCount);
                } else if (d.brand) {
                    totalBrand += parseInt(d.litterCount);
                }

                if (filterObject.length) {
                    if (filterObject.every((p) => d[p] == f[p]))
                        totalObject += parseInt(d.litterCount);
                } else if (d.object) {
                    totalObject += parseInt(d.litterCount);
                }

                if (filterMaterial.length) {
                    if (filterMaterial.every((p) => d[p] == f[p]))
                        totalMaterial += parseInt(d.litterCount);
                } else if (d.material) {
                    totalMaterial += parseInt(d.litterCount);
                }

                if (filterOther.length) {
                    if (filterOther.every((p) => d[p] == f[p]))
                        totalOther += parseInt(d.litterCount);
                } else if (d.other) {
                    totalOther += parseInt(d.litterCount);
                }

                if (filterUnclassified.length) {
                    if (filterUnclassified.every((p) => d[p] == f[p]))
                        totalOther += parseInt(d.litterCount);
                } else if (d.unclassified) {
                    totalUnclassified += parseInt(d.litterCount);
                }
            });

            let updated = data.reduce(
                (prev, next) => {
                    const countCategory = prev.category[next.category]
                        ? prev.category[next.category].count +
                          parseInt(next.litterCount)
                        : parseInt(next.litterCount);

                    const countBrand = prev.brand[next.brand]
                        ? prev.brand[next.brand].count +
                          parseInt(next.litterCount)
                        : parseInt(next.litterCount);

                    const countObject = prev.object[next.object]
                        ? prev.object[next.object].count +
                          parseInt(next.litterCount)
                        : parseInt(next.litterCount);

                    const countMaterial = prev.material[next.material]
                        ? prev.material[next.material].count +
                          parseInt(next.litterCount)
                        : parseInt(next.litterCount);

                    const countOther = prev.other[next.other]
                        ? prev.other[next.other].count +
                          parseInt(next.litterCount)
                        : parseInt(next.litterCount);

                    const countUnclassified = prev.unclassified[
                        next.unclassified
                    ]
                        ? prev.unclassified[next.unclassified].count +
                          parseInt(next.litterCount)
                        : parseInt(next.litterCount);
                    if (next.category) {
                        if (filterCategory.length) {
                            if (
                                filterCategory.every(
                                    (ele) => next[ele] == f[ele],
                                )
                            ) {
                                const percent =
                                    (countCategory / totalCategory) * 100;
                                prev.category[next.category] = {
                                    id: next.category,
                                    count: countCategory,
                                    name: next.category,
                                    percent: percent.toFixed(
                                        percent >= 100 ? 0 : 2,
                                    ),
                                };
                            }
                        } else {
                            const percent =
                                (countCategory / totalCategory) * 100;

                            prev.category[next.category] = {
                                id: next.category,
                                count: countCategory,
                                name: next.category,
                                percent: percent.toFixed(
                                    percent >= 100 ? 0 : 2,
                                ),
                            };
                        }
                    }

                    if (next.object) {
                        if (filterObject.length) {
                            if (
                                filterObject.every((ele) => next[ele] == f[ele])
                            ) {
                                const percent =
                                    (countObject / totalObject) * 100;
                                prev.object[next.object] = {
                                    id: next.object,
                                    count: countObject,
                                    name: next.object,
                                    percent: percent.toFixed(
                                        percent >= 100 ? 0 : 2,
                                    ),
                                };
                            }
                        } else {
                            const percent = (countObject / totalObject) * 100;
                            prev.object[next.object] = {
                                id: next.object,
                                count: countObject,
                                name: next.object,
                                percent: percent.toFixed(
                                    percent >= 100 ? 0 : 2,
                                ),
                            };
                        }
                    }
                    if (next.material) {
                        if (filterMaterial.length) {
                            if (
                                filterMaterial.every(
                                    (ele) => next[ele] == f[ele],
                                )
                            ) {
                                const percent =
                                    (countMaterial / totalMaterial) * 100;
                                prev.material[next.material] = {
                                    id: next.material,
                                    count: countMaterial,
                                    name: next.material,
                                    percent: percent.toFixed(
                                        percent >= 100 ? 0 : 2,
                                    ),
                                };
                            }
                        } else {
                            const percent =
                                (countMaterial / totalMaterial) * 100;
                            prev.material[next.material] = {
                                id: next.material,
                                count: countMaterial,
                                name: next.material,
                                percent: percent.toFixed(
                                    percent >= 100 ? 0 : 2,
                                ),
                            };
                        }
                    }

                    if (next.brand) {
                        if (filterBrand.length) {
                            if (
                                filterBrand.every((ele) => next[ele] == f[ele])
                            ) {
                                const percent = (countBrand / totalBrand) * 100;
                                prev.brand[next.brand] = {
                                    id: next.brand,
                                    count: countBrand,
                                    name: next.brand,
                                    percent: percent.toFixed(
                                        percent >= 100 ? 0 : 2,
                                    ),
                                };
                            }
                        } else {
                            const percent = (countBrand / totalBrand) * 100;
                            prev.brand[next.brand] = {
                                id: next.brand,
                                count: countBrand,
                                name: next.brand,
                                percent: percent.toFixed(
                                    percent >= 100 ? 0 : 2,
                                ),
                            };
                        }
                    }

                    if (next.other) {
                        if (filterOther.length) {
                            if (
                                filterOther.every((ele) => next[ele] == f[ele])
                            ) {
                                const percent = (countOther / totalOther) * 100;
                                prev.other[next.other] = {
                                    id: next.other,
                                    count: countOther,
                                    name: next.other,
                                    percent: percent.toFixed(
                                        percent >= 100 ? 0 : 2,
                                    ),
                                };
                            }
                        } else {
                            const percent = (countOther / totalOther) * 100;
                            prev.other[next.other] = {
                                id: next.other,
                                count: countOther,
                                name: next.other,
                                percent: percent.toFixed(
                                    percent >= 100 ? 0 : 2,
                                ),
                            };
                        }
                    }

                    if (next.unclassified) {
                        if (filterUnclassified.length) {
                            if (
                                filterUnclassified.every(
                                    (ele) => next[ele] == f[ele],
                                )
                            ) {
                                const percent =
                                    (countUnclassified / totalUnclassified) *
                                    100;
                                prev.unclassified[next.unclassified] = {
                                    id: next.unclassified,
                                    count: countUnclassified,
                                    name: next.unclassified,
                                    percent: percent.toFixed(
                                        percent >= 100 ? 0 : 2,
                                    ),
                                };
                            }
                        } else {
                            const percent =
                                (countUnclassified / totalUnclassified) * 100;
                            prev.unclassified[next.unclassified] = {
                                id: next.unclassified,
                                count: countUnclassified,
                                name: next.unclassified,
                                percent: percent.toFixed(
                                    percent >= 100 ? 0 : 2,
                                ),
                            };
                        }
                    }
                    return prev;
                },
                {
                    category: {},
                    object: {},
                    material: {},
                    brand: {},
                    other: {},
                    unclassified: {},
                },
            );

            let index = -1;
            let category = Object.keys(updated.category)
                .map((c) => updated.category[c])
                .sort((b, a) => a.count - b.count);
            if (category.length) {
                index = category.findIndex((item) => item.id == 'other');
                category.push(category.splice(index, 1)[0]);
            }

            let object = Object.keys(updated.object)
                .map((o) => updated.object[o])
                .sort((b, a) => a.count - b.count);
            if (object.length) {
                index = object.findIndex((item) => item.id == 'other');
                object.push(object.splice(index, 1)[0]);
            }

            let material = Object.keys(updated.material)
                .map((m) => updated.material[m])
                .sort((b, a) => a.count - b.count);
            if (material.length) {
                index = material.findIndex((item) => item.id == 'other');
                material.push(material.splice(index, 1)[0]);
            }

            let brand = Object.keys(updated.brand)
                .map((b) => updated.brand[b])
                .sort((b, a) => a.count - b.count);
            if (brand.length) {
                index = brand.findIndex((item) => item.id == 'other');
                brand.push(brand.splice(index, 1)[0]);
            }

            let unclassified = Object.keys(updated.unclassified)
                .map((b) => updated.unclassified[b])
                .sort((b, a) => a.count - b.count);
            if (unclassified.length) {
                index = unclassified.findIndex(
                    (item) => item.id == 'unclassified',
                );
                unclassified.push(unclassified.splice(index, 1)[0]);
            }

            let other = Object.keys(updated.other)
                .map((o) => updated.other[o])
                .sort((b, a) => a.count - b.count);

            resolve({ category, object, material, brand, other, unclassified });
        } catch (error) {
            Sentry.captureException(error);
            reject(error);
        }
    });
};

function ReportDemo({ data, totalCount, setMapFilters }, ref) {
    const [filter, setFilters] = useState({});
    const [filterOrder, setFilterOrder] = useState([]);
    const [loc, setLoc] = useState([]);
    // const [, setStandard] = useState(STANDARDS[0].key);
    // const [unit, setUnit] = useState(SHOW_UNIT[0].key);
    // const [standardList, setStandardList] = useState(STANDARDS);
    // const [unitList, setUnitList] = useState(SHOW_UNIT);
    const [, setUnit] = useState(SHOW_UNIT[0].key);
    const [, setStandardList] = useState(STANDARDS);
    const [, setUnitList] = useState(SHOW_UNIT);
    const [isRefreshing, setRefreshing] = useState(true);
    const [updated, setUpdatedData] = useState({
        category: [],
        object: [],
        material: [],
        brand: [],
        other: [],
        unclassified: [],
    });

    useEffect(() => {
        onLoad();
    }, [filter, data]);
    const { category, object, material, brand, other, unclassified } = updated;

    const onLoad = async () => {
        setRefreshing(true);
        const res = await getUpdatedData(filterOrder, filter, data);
        setRefreshing(false);
        setUpdatedData(res);
        setMapFilters({
            filterOrder,
            filter,
        });
    };
    const onSelectFilter = (id, type) => {
        setFilterOrder((f) => [...f, type]);
        setFilters((filter) => ({ ...filter, [type]: id }));
    };
    const onClearFilter = (type) => {
        setFilterOrder((f) => [...f.filter((item) => item != type)]);
        setFilters((filter) => {
            delete filter[type];
            return { ...filter };
        });
    };

    const clearAllHandler = () => {
        setFilters({});
        setMapFilters({});
        setFilterOrder([]);
        setLoc([]);
        setUnit(SHOW_UNIT[0].key);
        setStandardList([...STANDARDS]);
        setUnitList([...SHOW_UNIT]);
    };

    const loader = (
        <div className="buttonLoader">
            <LoadingComponent isLoading={true} />
        </div>
    );

    return totalCount > 0 ? (
        <div ref={ref} className="col-md-12">
            <div className="content-box card">
                <div className="row report-header">
                    <div>
                        <h2>Total Results</h2>
                        <h3>{numberWithCommas(totalCount)}</h3>
                        <label>Select a label to filter your result</label>
                    </div>
                    {isRefreshing ? loader : null}
                    <div className="dropdowns">
                        {filterOrder.length ? (
                            <div>
                                <button
                                    className="clearBtn"
                                    onClick={clearAllHandler}
                                >
                                    Clear All
                                </button>
                            </div>
                        ) : null}
                        {/* {unit == 'volume' || unit == 'weight' ? (
                            <div className="dropdown">
                                <DropDown
                                    label={'Standards'}
                                    menuData={standardList}
                                    onChange={(val) => setStandard(val)}
                                    variant={DROPDOWN_VARIANTS.LIST_SIMPLE}
                                />
                            </div>
                        ) : null}
                        <div className="dropdown">
                            <DropDown
                                label={'Show'}
                                menuData={unitList}
                                onChange={(val) => setUnit(val)}
                                variant={DROPDOWN_VARIANTS.LIST_SIMPLE}
                            />
                        </div> */}
                    </div>
                </div>

                <figure className="report-demo">
                    <div className="graphic">
                        <ReportChart
                            title="Category"
                            type="category"
                            tagData={category}
                            onSelectFilter={onSelectFilter}
                            filter={filter.category}
                            onClearFilter={onClearFilter}
                            selectedIds={loc}
                        />

                        <hr />
                        <ReportChart
                            title="Object"
                            type="object"
                            tagData={object}
                            onSelectFilter={onSelectFilter}
                            filter={filter.object}
                            onClearFilter={onClearFilter}
                            selectedIds={loc}
                        />

                        <hr />
                        <ReportChart
                            title="Material"
                            type="material"
                            tagData={material}
                            onSelectFilter={onSelectFilter}
                            filter={filter.material}
                            onClearFilter={onClearFilter}
                            selectedIds={loc}
                        />

                        <hr />
                        <ReportChart
                            title="Brand"
                            type="brand"
                            tagData={brand}
                            onSelectFilter={onSelectFilter}
                            filter={filter.brand}
                            onClearFilter={onClearFilter}
                            selectedIds={loc}
                        />

                        <hr />
                        {unclassified.length > 0 ? (
                            <ReportChart
                                title="Unclassified Tags"
                                type="unclassified"
                                tagData={unclassified}
                                onSelectFilter={onSelectFilter}
                                filter={filter.unclassified}
                                onClearFilter={onClearFilter}
                                selectedIds={loc}
                            />
                        ) : (
                            <ReportChart
                                title="Unclassified Tags"
                                type="other"
                                tagData={other}
                                onSelectFilter={onSelectFilter}
                                filter={filter.other}
                                onClearFilter={onClearFilter}
                                selectedIds={loc}
                            />
                        )}
                    </div>
                </figure>
            </div>
        </div>
    ) : null;
}

ReportDemo.propTypes = {
    data: PropTypes.array,
    setMapFilters: PropTypes.func,
    totalCount: PropTypes.number,
};

ReportDemo.defaultProps = {};

export default React.forwardRef(ReportDemo);
